import { createUseStyles } from 'react-jss'

import chevronArrowDown from '../../../assets/icons/chevron-arrow-down.svg'

import { darkGrey, lightGrey, mediumGrey } from '../../../styles/const/colors'
import { defaultBorderRadius, transitionShort } from '../../../styles/const/common'
import { phonesDown } from '../../../styles/const/breakpoints'

export default createUseStyles({
  inputWrapper: {
    position: 'relative'
  },
  input: {
    height: '40px !important',
    borderColor: `${lightGrey} !important`,
    borderRadius: `${defaultBorderRadius} !important`,
    paddingLeft: '75px !important',
    color: `${darkGrey} !important`,
    width: '100% !important',
    fontSize: 14,
    '&.open': {
      zIndex: '0 !important'
    },
    [`@media screen and (${phonesDown})`]: {
      height: '34px !important',
      fontSize: '12px !important'
    }
  },
  dropdown: {
    borderColor: `${lightGrey} !important`,
    backgroundColor: 'white !important',
    '& .arrow': {
      width: '12px !important',
      height: '8px !important',
      backgroundColor: mediumGrey,
      maskImage: `url(${chevronArrowDown})`,
      maskSize: 10,
      maskRepeat: 'no-repeat',
      border: 'none !important',
      left: '32px !important',
      transition: transitionShort,
      transform: 'translateY(-1px)'
    },
    '&.open .arrow': {
      transform: 'rotate(180deg)'
    },
    '& .selected-flag': {
      paddingLeft: 10,
      width: 63
    }
  }
})
